import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  valueBox: {
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: 5,
    flex: 1,
  },
  valueTypography: {
    fontSize: 70,
  },
  labelBox: {
    textAlign: 'center',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  },
  container: {
    border: '2px solid',
    borderColor: theme.palette.primary.main,
    borderRadius: 5,
    height: '100%',
  },
  titleTypography: {
    fontWeight: 800,
  },
}))

export default styles
